import React, { useContext } from "react";
import { CartContext } from "../../context/cart.context";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";

const ProductCard1 = ({ product }) => {
  const { addItemToCart, cartItems, removeItemToCart } =
    useContext(CartContext);

  // Find the cart item for this product
  const cartItem = cartItems.find((item) => item.id === product.id);
  const quantity = cartItem ? cartItem.quantity : 0;

  // ✅ to Use live cart values when the item is in the cart, fall back to catalog price otherwise

  // Helper: parse "7.62 AED" -> 7.62
  const parseAed = (val) => parseFloat(String(val).replace(/[^\d.]/g, "")) || 0;

  // Helper: 15.24 -> "15.24 AED"
  const formatAed = (val) => `${val.toFixed(2)} AED`;

  // ✅ Line total = unit price (from cart, discount-applied) × qty
  const displayPrice = cartItem
    ? formatAed(parseAed(cartItem.price) * quantity)
    : product.price;

  const displayActualPrice = cartItem
    ? formatAed(parseAed(cartItem.actualprice) * quantity)
    : product.actualprice;

  const displayDiscount = cartItem
    ? cartItem.discountPercent
    : product.discount;

  // ✅ Badge logic
  const dbDiscount = Number(product.discount) || 0;
  const hasPriceGap = cartItem
    ? parseAed(cartItem.price) < parseAed(cartItem.actualprice)
    : parseAed(product.price) < parseAed(product.actualprice);

  const showBadge = dbDiscount > 0 || hasPriceGap;
  const badgeLabel = product.badgeText || "PROMO"; // use DB value, fallback if missing

  const addProductToCart = () => {
    addItemToCart(product);
  };

  const removeProductToCart = () => {
    removeItemToCart(product);
  };

  return (
    <div
      className="w-72 border-[1px] border-primary font-poppins shadow-md rounded-xl
      duration-500 hover:scale-105 bg-primaryLight hover:shadow-xl hover:bg-primaryVeryLight relative"
    >
      {/* Discount badge — % from DB if present, otherwise PROMO for cart-calculated discounts (e.g. 5-Gallon bulk tiers) */}
      {showBadge && (
        <div>
          <div className="absolute right-7">
            <div className="rounded-b-md bg-primary w-14 h-14"></div>
          </div>

          <div className="absolute right-7 w-14 flex justify-center items-center">
            <span
              className={`flex flex-col text-textWhite font-medium leading-tight ${
                dbDiscount > 0 ? "text-C12" : "text-C13"
              }`}
            >
              {badgeLabel}
            </span>
          </div>
        </div>
      )}

      <div className="bg-primaryVeryLight cursor-wait rounded-t-xl">
        <img
          src={product.imageSrc}
          alt={product.imageAlt}
          className="h-80 w-72 drop-shadow-lg object-contain scale-[.85] rounded-t-xl"
        />
      </div>
      <div className="group px-4 py-3 w-72 h-44 bg-primaryLight rounded-b-xl  hover:bg-secondary text-cool-gray-500 hover:text-textWhite rounded-t-2xl duration-500 hover:shadow-xl">
        <div className="flex flex-row justify-between gap-2">
          <div>
            <div className="mt-2 max-w-[150px]">
              <span className="text-cool-gray-500  text-xl font-poppins uppercase">
                {product.description}
              </span>
              <br />
              {product.instock ? (
                <span className="text-green-500"></span>
              ) : (
                <span className="text-red-500 font-poppins text-C12 font-normal ">
                  Out of Stock
                </span>
              )}
            </div>
            <p className="text-C14 text-cool-gray-400 truncate ">&nbsp;</p>
            <div className="flex items-center"></div>
            <div className="flex items-center">
              <div className="flex items-center">
                <p className="text-xl font-poppins font-semibold  my-3">
                  {displayPrice}
                </p>
                {/* If the prices are different, show the actual price struck through */}
                {displayPrice !== displayActualPrice && (
                  <del>
                    <p className="text-base font-poppins text-gray-600 ml-4">
                      {displayActualPrice}
                    </p>
                  </del>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex flex-col gap-2 justify-stretch p-1 items-center">
              <button
                type="button"
                onClick={(e) => {
                  if (!product.instock) {
                    e.preventDefault();
                    return;
                  }
                  addProductToCart();
                }}
                className={`flex w-10 h-[35px] border-[1px] border-primary rounded-md
                        hover:bg-secondaryHover hover:text-textWhite group-hover:border-cool-gray-200 items-center
                        ${!product.instock ? "cursor-not-allowed" : ""}`}
              >
                <PlusIcon className="mx-auto text-[12px] w-6 items-center justify-center text-center" />
              </button>
              <div
                className="w-10 h-[35px] border-secondary mx-auto items-center justify-center align-middle 
                   inline-flex border-[0px] rounded-md"
              >
                <span className="text-2xl font-bold">{quantity}</span>
              </div>
              {quantity > 0 ? (
                <button
                  type="button"
                  onClick={removeProductToCart}
                  className="flex w-10 h-[35px] border-[1px] border-secondary group-hover:border-cool-gray-200
                      rounded-md hover:bg-secondaryHover hover:text-textWhite items-center"
                >
                  <MinusIcon className="mx-auto text-[12px] w-6  items-center justify-center text-center" />
                </button>
              ) : (
                <span
                  className="flex w-10 h-[35px] border-[1px] border-secondary group-hover:border-cool-gray-200
                      rounded-md items-center opacity-50 cursor-not-allowed"
                >
                  <MinusIcon className="mx-auto text-[12px] w-6  items-center justify-center text-center" />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard1;
